import getQueryParamValue from '@quicktools/shared-components/utils/queryParams';

import { DEFAULT_TONE, VALID_TONES, CATEGORIES } from '../../constants';

import { ToolCategory } from './types';

export const getToneFromUrl = () => {
  const param = getQueryParamValue('tone');

  if (VALID_TONES.find((t) => t === param)) return param;

  return DEFAULT_TONE;
};

export function getHeaderLink(category: number) {
  if (CATEGORIES[category].path.landing) {
    return `/text/${CATEGORIES[category].path.landing}/`;
  }

  return '/text/ai-writer/';
}

export function getLandingPageHref(category: number) {
  if (CATEGORIES[category].path.landing) {
    return `/text/${CATEGORIES[category].path.landing}/`;
  }
  return getCategoryHref(category);
}

export function getCategoryHref(category: number) {
  return `/text/ai-writer/${CATEGORIES[category].path.self}/`;
}

export const getCategoryName = (category: number) => {
  if (!category) {
    return '';
  }

  return CATEGORIES[category].name;
};

export const getHideGenerateMore = (category: ToolCategory) =>
  CATEGORIES[category].hideGenerateMore;

export const allowRephrasing = (category: ToolCategory) => {
  if (!category) {
    return false;
  }

  return CATEGORIES[category].rephrase;
};

export const getShowLoadingResults = (category: ToolCategory) => {
  const currentCategory = CATEGORIES[category];

  return !(currentCategory.hasOneResult && currentCategory.hideGenerateMore);
};
